"use strict";
var baseGet = require('./_baseGet');
function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;
//# sourceMappingURL=get.js.map